import { createContext, ReactNode, useState } from 'react'
import {
  FilterType,
  GetUserCompanyAssociationFilter,
} from 'store/company/company.types'

export type AddressProviderValue = {
  setFilterType: (filterType: FilterType) => void
  setSearchText: (searchText: string) => void
  selectedAssociationId: string | null
  setSelectedAssociationId: (id: string | null) => void
  entityTabIndex: number
  setEntityTabIndex: (index: number) => void
  detailTabIndex: number
  setDetailTabIndex: (index: number) => void
} & GetUserCompanyAssociationFilter

interface AddressProviderProps {
  children: ReactNode
}

export const AddressContext = createContext<AddressProviderValue | undefined>(
  undefined
)

const AddressProvider = ({ children }: AddressProviderProps) => {
  const [filterType, setFilterType] = useState<FilterType>('factoring')
  const [searchText, setSearchText] = useState<string>('')
  const [selectedAssociationId, setSelectedAssociationId] = useState<
    string | null
  >(null)
  const [entityTabIndex, setEntityTabIndex] = useState(0)
  const [detailTabIndex, setDetailTabIndex] = useState(0)

  return (
    <AddressContext.Provider
      value={{
        filterType,
        searchText,
        selectedAssociationId,
        entityTabIndex,
        detailTabIndex,
        setFilterType,
        setSearchText,
        setSelectedAssociationId,
        setEntityTabIndex,
        setDetailTabIndex,
      }}
    >
      {children}
    </AddressContext.Provider>
  )
}

export default AddressProvider
